var map = {
	"./addon.svg": 4887,
	"./calendar.svg": 2425,
	"./cancel.svg": 7727,
	"./card.svg": 9682,
	"./copy.svg": 785,
	"./delivery.svg": 4444,
	"./esim.svg": 8468,
	"./plus.svg": 721,
	"./portin.svg": 8348,
	"./replacement.svg": 5218,
	"./sprite.svg": 1569,
	"./unpaid.svg": 5071,
	"./warning.svg": 8279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9294;